// extracted by mini-css-extract-plugin
export default {"group":"index-module__group___KB1Lr"};